import Store from "App/Store.js";

export default checkoutBasketLoading => Store.dispatch({type: "checkoutBasketLoading", checkoutBasketLoading});
